import React from "react";
import {
	AutocompleteInput,
	ReferenceInput,
	required,
	SimpleForm,
} from "react-admin";

const Form = ({ isAdmin, create, ...props }) => {
	return (
		<SimpleForm {...props} redirect="list">
			{isAdmin && (
				<ReferenceInput
					source="user_id"
					reference="users"
					validate={[required()]}
				>
					<AutocompleteInput />
				</ReferenceInput>
			)}
		</SimpleForm>
	);
};
export default Form;
